import css from './header.module.scss';
import {Searchbox} from '../../../components/searchbox/searchbox';

export const Header = (): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.headerContainer}>
				<Searchbox placeholder="Songs" onValueChange={console.log} />
			</div>
		</div>
	);
};
